// extracted by mini-css-extract-plugin
export default {"form":"LoginFormV4_form__ocg8g","login-btn":"LoginFormV4_login-btn__IHX2U","secondary-btn":"LoginFormV4_secondary-btn__+8COR","error":"LoginFormV4_error__hxwUy"};